import React, { memo } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { FeatureSection } from './components/FeatureSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { CalendarIcon, CheckCircleIcon, ImageIcon, BellIcon, SettingsIcon } from 'lucide-react';
export function App() {
  return <div className="w-full min-h-screen bg-white" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-0">
      <Navbar data-id="element-1" />

      <Hero data-id="element-2" />

      <div id="features" data-id="element-3">
        <FeatureSection badge="Calendar" icon={CalendarIcon} title="One calendar for the" highlight="whole family" description="See everyone's schedules, events, and today's plans at a glance." imageUrl="https://cdn.magicpatterns.com/uploads/5ZBmk26BubsdyadAN5MyVc/calendar-1.png" imageAlt="Family Calendar Feature" reverse={false} data-id="element-4" />

        <FeatureSection badge="To-do" icon={CheckCircleIcon} title="Shared to-dos" highlight="made simple" description="Organize chores, errands, and private tasks in one easy checklist." imageUrl="https://cdn.magicpatterns.com/uploads/kwYXh1TRMCtd7b5tuvMgvN/calendar-2.png" imageAlt="To-do List Feature" reverse={true} data-id="element-5" />

        <FeatureSection badge="Timeline" icon={ImageIcon} title="Keep everyday" highlight="memories together" description="Share family moments, photos, and stories in a private timeline." imageUrl="https://cdn.magicpatterns.com/uploads/8mH737gMTuCqyXr6ZGoX4g/calendar-3.png" imageAlt="Timeline Feature" reverse={false} data-id="element-6" />

        <FeatureSection badge="Notifications" icon={BellIcon} title="Never miss a" highlight="family update" description="Get instant alerts for posts, likes, invites, and shared to-dos." imageUrl="https://cdn.magicpatterns.com/uploads/8yfzRXhN4VS9E9eQRY3wP1/calendar-4.png" imageAlt="Notifications Feature" reverse={true} data-id="element-7" />

        <FeatureSection badge="Settings" icon={SettingsIcon} title="Manage your family" highlight="with ease" description="Invite members and customize calendar and notification preferences." imageUrl="https://cdn.magicpatterns.com/uploads/91wqBiQbm3PyRQUQBHHFgC/calendar-5.png" imageAlt="Settings Feature" reverse={false} data-id="element-8" />
      </div>

      <CtaSection data-id="element-9" />

      <Footer data-id="element-10" />
    </div>;
}